import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '../auth.service';
import {environment} from "../../../environments/environment";
import {Alert} from "../../shared/alert/Alert";
import {AlertService} from "../../shared/alert/alert.service";

@Component({
  moduleId: module.id,
  templateUrl: 'login.component.html'
})

export class LoginComponent implements OnInit {
  model: any = {};
  returnTo = "";

  constructor(
      private router: Router,
      private authenticationService: AuthService,
      private alertService: AlertService,
      private route: ActivatedRoute) {

    route.queryParams.subscribe(params => {
      if(params.returnTo) {
        this.returnTo = params.returnTo;
        localStorage.setItem('returnUrl', this.returnTo);
      } else {
        localStorage.removeItem('returnUrl');
      }
    })
  }

  ngOnInit() {
    // reset login status
    //this.authenticationService.logout();
  }

  login() {
    if (environment.production === false) {
      this.authenticationService.fakeLogin('test@penceo.com', 'test').subscribe(result => {
        if (result === true) {
          // login successful
          if(!this.returnTo) {
            this.router.navigate(['/']);
          } else {
            this.router.navigateByUrl(this.returnTo);
          }
        } else {
          this.router.navigate(['/not-authorized']);
        }
      }, err => {
        if (err.status === 403) {
          this.router.navigate(['/not-authorized']);
        } else {
          console.log(err)
          this.showError('Authentication failed');
          this.router.navigate(['/login']);
        }
      });

    } else {
      this.authenticationService.redirectToAuthScreen();
    }
  }

  showError(message) {
    const alert = new Alert(message);
    alert.autoHide = false;
    this.alertService.danger(alert);
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/login/login.component.ts